module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"headTitle":"Type opdracht","headDescription":"Geef aan naar wat voor type makelaar je op zoek bent.","title":"Type opdracht","nextBtn":"Volgende","subtext":"Gratis & volledig vrijblijvend"}}')
  delete Component.options._Ctor
}
